require('./change-password-key-template.html');

exports.inject = function(module) {
  module.config(['$routeProvider', function($routeProvider) {
    $routeProvider.when('/accounts/password/reset/key/:key', {
      templateUrl: 'change-password-key-template.html',
      controller: 'ChangePasswordKeyController',
      loginLayout: true
    });
  }]);
  module.controller('ChangePasswordKeyController', ['$scope', '$timeout', '$location', '$routeParams', 'Auth', exports.controller]);
};

exports.controller = function($scope, $timeout, $location, $routeParams, Auth) {
  $scope.changePasswordSubmit = function($event, password, passwordConfirm) {
    //$(".login-page").addClass('logging-in');
    Auth.resetPassword($routeParams.key, password, passwordConfirm).then(
      function() {
         //$(".login-page").removeClass('logging-in');
         $location.path('/dashboard');
      },
      function(response) {
        if(!response.data.success) {
          //$(".login-page").removeClass('logging-in');
          console.log('TODO: show error message');
        }
      }
    );
  };
};



/*****************
 ** WEBPACK FOOTER
 ** ./app/authorization/change-password-key-controller.js
 ** module id = 302
 ** module chunks = 0
 **/